require('./mortgageRequestManagerPanel.scss');

// @vendors
const { formatText, FormattedText, getLanguage, hasTranslation } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const mortgageRequestStates = require('constants/mortgageRequestStates');

// @ actions
const { getMortgageActivities } = require('actions/mortgageRequest/mortgageRequestActivities');

class MortgageRequestManagerPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ordenNm: '1'
        };
    }

    componentDidMount() {
        const { getMortgageActivities } = this.props;
        const language = getLanguage();
        getMortgageActivities(language);
    }

    componentWillReceiveProps() {
        const { dataProprietors } = this.props;
        const dataProprietorList = dataProprietors.get('data');

        if (dataProprietorList && dataProprietorList.size) {
            const dataProprietor = dataProprietorList.getIn(['0']);
            const proprietorOrdenNm = dataProprietor.getIn(['datosPersonales', 'ordenNm'], '1');

            this.setState({
                ordenNm: proprietorOrdenNm
            });
        }
    }

    render() {
        const { mortgageRequestState, mortgageActivities } = this.props;
        const descripcion = mortgageActivities.get('descripcion');
        const managerTitle = formatText('mortgageRequestManagerInfo-yourManager');
        let descripcionElement;
        let messageKey, messageLink;

        if (mortgageActivities.get('isFetching')) {
            descripcionElement = <LoadingSection />;
        } else {
            descripcionElement = (
                <p className="mortgage-request-manager-panel__text">
                    {descripcion}
                </p>
            );
        }

        if (mortgageRequestState.get('estado')) {
            const currentStatus = mortgageRequestState.get('estado');
            switch (currentStatus) {
                case mortgageRequestStates.APORTAR_DOC:
                case mortgageRequestStates.CONFIRMA_DATOS_T2:
                    messageKey = 'APORTAR_DOCUMENTACION';
                    break;
                case mortgageRequestStates.AUT_CIRBE:
                case mortgageRequestStates.AUT_CIRBE_CO:
                case mortgageRequestStates.WAIT_CIRBE_COT:
                    messageKey = 'AUTORIZAR_CIRBE';
                    break;
                case mortgageRequestStates.DATOS_VIV:
                    messageKey = 'DATOS_VIVIENDA';
                    break;
                case mortgageRequestStates.TRAMITAR_NS:
                    messageKey = 'TRAMITAR_NOTAS';
                    break;
                case mortgageRequestStates.WAIT_NS:
                    messageKey = 'PENDIENTE_NOTA_GESTORIA';
                    break;
                case mortgageRequestStates.PROBLEMA_NS:
                    messageKey = 'PROBLEMA_NOTA_SIMPLE';
                    break;
                case mortgageRequestStates.PEND_TASACION:
                    messageKey = 'APORTA_TASACION';
                    break;
                case mortgageRequestStates.TRAMITAR_TAS:
                case mortgageRequestStates.WAIT_DICTAMEN:
                    messageKey = 'PENDIENTE_TASACION_GESTORIA';
                    break;
                case mortgageRequestStates.ANALISIS_TAS:
                    messageKey = 'TASACION_TERMINADA';
                    break;
                case mortgageRequestStates.APROBADO_RIESGOS:
                case mortgageRequestStates.GENERANDO_OV:
                    messageKey = 'APROBADO_RIESGOS';
                    break;
                case mortgageRequestStates.PROV_FONDOS:
                    messageKey = 'PENDIENTE_PROVISION_FONDOS';
                    break;
                case mortgageRequestStates.PEND_MMPP:
                    messageKey = 'PENDIENTE_MEDIOS_PAGOS';
                    break;
                case mortgageRequestStates.PEND_SALDO:
                    messageKey = 'PENDIENTE_SALDO';
                    break;
                case mortgageRequestStates.PEND_FIRMA:
                    messageKey = 'PENDIENTE_FIRMA';
                    break;
                case mortgageRequestStates.FIRMADO:
                    messageKey = 'FIRMADO';
                    break;
                case mortgageRequestStates.MODEL_CORRECT:
                    messageKey = 'DENEGADO_RIESGOS';
                    break;
                case mortgageRequestStates.ERROR_BUREAUS:
                    messageKey = 'DENEGADO_ASNEF';
                    break;
                case mortgageRequestStates.OFRECER_FINANCIACION_GASTOS:
                    messageKey = 'OFRECER_FINANCIACION_GASTOS';
                    break;
                case mortgageRequestStates.APERTURA_CUENTA:
                    messageKey = 'APERTURA_CUENTA';
                    break;
                case mortgageRequestStates.ESPERA_DOC_FIRMA:
                    messageKey = 'ESPERA_DOC_FIRMA';
                    break;
                case mortgageRequestStates.ESPERA_ACTA_NOTARIO:
                    messageKey = 'ESPERA_ACTA_NOTARIO';
                    break;
                case mortgageRequestState.GESTION_FECHA_FIRMA:
                    messageKey = 'GESTION_FECHA_FIRMA';
                    break;
                default:
                    messageKey = 'DEFAULT';
                    break;
            }
        } else {
            messageKey = 'DEFAULT';
        }

        const subtitleKey = `mortgageRequestOrderStatus-${messageKey}_Subtitle`;

        if (hasTranslation(subtitleKey)) {
            messageLink = (
                <OKLink
                    modifier="editorial"
                    id={'btnPersonalInfo'}
                    to={formatText(`mortgageRequestOrderStatus-${messageKey}_Link`, [
                        this.state.ordenNm
                    ])}
                >
                    <FormattedText value={subtitleKey} />
                </OKLink>
            )
        }

        return (
            <ContentBox
                title={formatText('mortgageRequestPanel-managerSectionTitle1')}
                smallTitle={true}
                className="mortgage-request-manager-panel__no-padding-bottom"
            >
                <div>
                    {descripcionElement}
                    {messageLink}
                </div>
                <WebappRender>
                    <hr />
                    <MortgageRequestManagerInfo managerTitle={managerTitle} />
                </WebappRender>
            </ContentBox>
        );
    }
}

MortgageRequestManagerPanel.propTypes = {
    mortgageRequestState: PropTypes.object,
    dataProprietors: PropTypes.object,
    getMortgageActivities: PropTypes.func,
    mortgageActivities: PropTypes.object
};
module.exports.constructor = MortgageRequestManagerPanel;

module.exports.MortgageRequestManagerPanel = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        dataProprietors: state.mortgageRequestDataProprietor,
        mortgageActivities: state.mortgageRequestActivities
    }),
    {
        getMortgageActivities: getMortgageActivities
    }
)(MortgageRequestManagerPanel);
